import React from 'react';
import { ArrowRightIcon } from '@radix-ui/react-icons';

import { DateSelector } from '../../../components/date-selector/date-selector';
import { type PlainDate } from '../../../core/services/plain-date';

import styles from './timeframe.module.scss';
interface TimeFrameProps {
  startDate: PlainDate | null | undefined;
  dueDate: PlainDate | null | undefined;
  onUpdate: (values: { dueDate?: PlainDate | null; startDate?: PlainDate | null }) => void;
}

export const TimeFrame: React.FC<TimeFrameProps> = ({ startDate, dueDate, onUpdate }) => (
  <div className={styles['container']}>
    <DateSelector
      date={startDate}
      max={dueDate}
      field={'startDate'}
      onUpdate={(startDate) => onUpdate({ startDate })}
    />
    <ArrowRightIcon />
    <DateSelector
      date={dueDate}
      min={startDate}
      field={'dueDate'}
      onUpdate={(dueDate) => onUpdate({ dueDate })}
    />
  </div>
);
